import './PACSStatusSetting.scss';

import React from 'react';

import { PACSCommunicationContext } from 'app/components/PACSCommunicationProvider/context';
import PACSCommunicationInjector from 'app/injectors/PACSCommunication/context';
import { selectPACSConfiguration, setPACSEnabled } from 'app/redux/PACSConfiguration/reducer';
import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PACSAssociationStatus from 'app/components/PACSAssociationStatus';
import { Button } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@tanstack/react-query';
import queryPACSAssociationStatusOptions, {
  addAllPresentationContextsToConfiguration,
} from 'app/queries/queryPACSAssociationStatusOptions';
import useMinDurationLoadingState from 'app/hooks/useMinDurationLoadingState';
import ErrorMessage from 'app/components/PACSErrorMessage';

export function PACSStatusSetting() {
  const PACSCommunicationCtor = useContext(PACSCommunicationInjector);
  if (!PACSCommunicationCtor) return null;

  const pacsCommunication = useContext(PACSCommunicationContext);
  const pacsConfiguration = useSelector(selectPACSConfiguration);
  const dispatch = useDispatch();
  const pacsEnabled = pacsConfiguration.enabled;

  const toggleConfiguration = useCallback(() => {
    dispatch(setPACSEnabled(!pacsEnabled));
  }, [dispatch, pacsEnabled]);

  const { refetch, error, ...rest } = useQuery({
    ...queryPACSAssociationStatusOptions(
      addAllPresentationContextsToConfiguration(pacsConfiguration),
      { pacsCommunication }
    ),
    enabled: pacsConfiguration.enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
  const isFetching = useMinDurationLoadingState(rest.isFetching, 1000);

  return (
    <div>
      <div className="pacs-configuration-row__status-group">
        <PACSAssociationStatus pacsConfiguration={pacsConfiguration} />
        <Button
          size="small"
          disabled={pacsEnabled === undefined}
          onClick={toggleConfiguration}
          className={`pacs-configuration-row__enable-button pacs-configuration-row__enable-button--${
            pacsEnabled === true ? 'disable' : 'enable'
          }`}
        >
          {pacsEnabled === true ? (
            <FormattedMessage id="account.configuration.pacs.disable" />
          ) : (
            <FormattedMessage id="account.configuration.pacs.enable" />
          )}
        </Button>
        <Button
          secondary
          onClick={() => refetch()}
          loading={isFetching}
          disabled={isFetching}
          size="tiny"
        >
          <FormattedMessage id="account.configuration.pacs.test" />
        </Button>
      </div>
      {error && <ErrorMessage error={error} titleID="pacs.message.test_error.title" />}
    </div>
  );
}
